module.exports = __webpack_public_path__ + "static/lion1-51bb8e8888786080cbdd76ade52473eb.png";